import { type ComponentProps, memo } from 'react'
import Image from 'next/image'
import clsx from 'clsx'
import { getImgSrc } from '@/services/storyblok/Storyblok.helpers'
import { BasePillow, type PillowSizeProp } from 'ui/src/components/BasePillow/BasePillow'
import { pillowSizeStyles } from 'ui/src/components/BasePillow/BasePillow.css'
import { tokens } from 'ui/src/theme/tokens.css'

type Props = {
  size: PillowSizeProp
  src?: string
  alt?: string | null
  imagePriority?: boolean
} & Omit<ComponentProps<typeof Image>, 'src' | 'alt' | 'priority'>

export const Pillow = memo(({ className, src, alt, size, imagePriority, ...props }: Props) => {
  if (!src) {
    return <BasePillow className={className} size={size} fill={tokens.colors.surface.opaque.primary} />
  }

  return (
    <Image
      className={clsx(pillowSizeStyles(size), className)}
      src={getImgSrc(src)}
      alt={alt ?? ''}
      width={272}
      height={272}
      decoding="sync"
      quality={75}
      loading={imagePriority ? 'eager' : props.loading}
      fetchPriority={imagePriority ? 'high' : props.fetchPriority}
      {...props}
    />
  )
})
Pillow.displayName = 'Pillow'
